export enum AansluitingType {
  Onbekend = 'geen aansluitingtype bekend',
  Gas = 'gas',
  Electriciteit = 'stroom',
  ElectriciteitEnGas = 'stroom en gas',
}
